module.exports = __webpack_public_path__ + "static/lighting-table-striped-a82e6794ad78e96ac0c526366dc70c67.png";